/**
 * @sunflowerlab
 * @author Ashish Kumar
 */
export class AppMessages {
  public static readonly passwordChange: string = 'You have successfully changed your secret.';
  public static readonly duplicateFilterName: string = 'A filter already exists in the system with this name. Please rename your filter and save again.';
  public static readonly noResultForCriteria: string = 'There is no data that matches your search criteria.';
}
